import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 59); // 14:59 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `00:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 right-0 z-50 bg-zinc-900 border-b border-green-500/30 py-2 px-4 shadow-lg" data-id="element-206">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-207">
        <div className="flex items-center gap-2" data-id="element-208">
          <motion.div animate={{
          opacity: [1, 0.5, 1]
        }} transition={{
          duration: 1.5,
          repeat: Infinity
        }} className="w-2 h-2 rounded-full bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.8)]" data-id="element-209" />
          <span className="text-xs sm:text-sm font-bold text-white uppercase tracking-wide" data-id="element-210">
            OFERTA LIMITADA:{' '}
            <span className="text-zinc-400 font-normal normal-case" data-id="element-211">
              Solo quedan 7 cupos con bonus
            </span>
          </span>
        </div>
        <div className="font-mono text-sm sm:text-base font-bold text-green-400 bg-black/30 px-3 py-0.5 rounded border border-green-500/20" data-id="element-212">
          {formatTime(timeLeft)}
        </div>
      </div>
    </div>;
}